import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";
import SelectCategory from "@/pages/SelectCategory";
import Questionnaire from "@/pages/Questionnaire";
import Result from "@/pages/Result";
import PublicResult from "@/pages/PublicResult";
import Admin from "@/pages/admin/Admin";
import Pembayaran from "@/pages/Pembayaran";
import AuthCallback from "@/pages/AuthCallback";

function AppRouter() {
  const location = useLocation();
  if (location.hash && location.hash.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/pilih" element={<SelectCategory />} />
      <Route path="/mulai/:category" element={<Questionnaire />} />
      <Route path="/hasil/:publicId" element={<Result />} />
      <Route path="/result/:publicId" element={<PublicResult />} />
      <Route path="/pembayaran" element={<Pembayaran />} />
      <Route path="/admin" element={<Admin />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App grain rk-bg">
      <Toaster theme="dark" position="top-center" richColors />
      <BrowserRouter>
        <AppRouter />
      </BrowserRouter>
    </div>
  );
}

export default App;
